export default __webpack_public_path__ + "media/images/images/flags/al-55b0e63e758d1ed340a38a7761ed9368.png";